import { OFFLINE_SERVICE, OfflineService } from "@cervval.js/client-html5-core/src/services/offline.service";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { ValueOrFunction, getVOFValue } from "@cervval.js/common/src/tools/object.tools";
import { PropertyInfos, TypeInfos, decorateProxyWithCachedGetValue } from "@cervval.js/ts-reflect/decorator";
import { CLIENT_ROUTES_SERVICE, ClientRouteOptions, ClientRoutesService } from "./clientRoutes.service";

export interface OfflineRouteOptions {
    /** enabled offline cache support for all routes or a specific set or routes */
    enabled: true | string[];

    /** offline cache expiry delay in seconds (default 1 day) */
    cacheExpirationDelaySeconds?: number;
}

/**
 * ClientAjaxProxy decorator that proxies the call to server functions
 * @param options
 * @param options.urlPrefix optional prefix to put before proxiedPropertyName
 * @param options.offline optional add offline support
 * @param typeInfos Typed decorator => typeInfos parameter added at build time (see utils/reflect-ts)
 */
export function TypedClientAjaxProxy(options?: { urlPrefix?: ValueOrFunction<string>, offline?: OfflineRouteOptions }, typeInfos?: TypeInfos): (classPrototype: unknown, propertyKey: string) => void {
    return decorateProxyWithCachedGetValue((target: unknown, propertyKey: string, proxiedPropertyName: string, proxiedPropertyInfos: PropertyInfos) => {
        const urlPrefix = getVOFValue(options?.urlPrefix) ?? "";
        const clientRoutesService = injector.get<ClientRoutesService>(CLIENT_ROUTES_SERVICE);
        // return a function that calls clientRoutesService.callJson
        const fn = (params: unknown, routeOptions: ClientRouteOptions): Promise<unknown> => {
            return clientRoutesService.callJson({
                url: urlPrefix + proxiedPropertyName,
                params
            }, routeOptions);
        };
        if (options?.offline) {
            const offlineService = injector.find<OfflineService>(OFFLINE_SERVICE);
            if (offlineService) {
                return offlineService.wrap({
                    fn,
                    offlineFn: (params: unknown, routeOptions: ClientRouteOptions) => {
                        return fn(params, { ...routeOptions, doNotShowDialogOnErrors: true });// do not show error to user
                    },
                    cacheResult: {
                        cacheUid: urlPrefix + proxiedPropertyName,
                        expirationDelaySeconds: options.offline?.cacheExpirationDelaySeconds
                    }
                });
            }
        }
        return fn;
    }, typeInfos);
}
